interface FilterPillProps {
  label: string;
  active: boolean;
  onClick: () => void;
}

export default function FilterPill({ label, active, onClick }: FilterPillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors ${
        active
          ? "bg-primary-500 text-background-50"
          : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
      }`}
    >
      {label}
    </button>
  );
}